/** Distanz in Axialkoordinaten: (|dq| + |dq+dr| + |dr|) / 2 */
export function hexDistance(a, b) {
    const dq = a.q - b.q;
    const dr = a.r - b.r;
    return (Math.abs(dq) + Math.abs(dq + dr) + Math.abs(dr)) / 2;
}
const DIRECTIONS = [
    { q: 1, r: 0 },
    { q: 1, r: -1 },
    { q: 0, r: -1 },
    { q: -1, r: 0 },
    { q: -1, r: 1 },
    { q: 0, r: 1 },
];
/** Alle Felder im Abstand genau `radius` um `center` (radius 0 = center selbst). */
export function hexRing(center, radius) {
    if (radius === 0)
        return [center];
    const out = [];
    let cur = { q: center.q + DIRECTIONS[4].q * radius, r: center.r + DIRECTIONS[4].r * radius };
    for (let side = 0; side < 6; side++) {
        for (let step = 0; step < radius; step++) {
            out.push(cur);
            const d = DIRECTIONS[side];
            cur = { q: cur.q + d.q, r: cur.r + d.r };
        }
    }
    return out;
}
/** Spirale von innen nach aussen – zum Platzieren neuer Stoecke nahe der Mitte. */
export function* hexSpiral(center, maxRadius) {
    for (let r = 0; r <= maxRadius; r++)
        for (const c of hexRing(center, r))
            yield c;
}
//# sourceMappingURL=hex.js.map